import { Tooltip } from "antd"
import { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import ApiClient from "../../methods/api/apiClient"
import Layout from "../../components/global/layout"
import moment from "moment"
import loader from "../../methods/loader"

const TransactionDetail = () => {
    const { id } = useParams()
    const navigate = useNavigate()
    const [detail, setDetail]: any = useState()

    useEffect(() => {
        if (id) {
            getDetail()
        }
    }, [])

    const getDetail = () => {
        loader(true)
        ApiClient.get(`transactions/detail?id=${id}`).then(res => {
            if (res.success) {
                setDetail(res?.data)
            }
            loader(false)
        })
    }

    return (
        <>
            <Layout>
                <div className="section-listinngs px-4 lg:px-16 pt-6">
                    <div className="flex items-center mb-8 bg-[#ffe9d0] font-medium p-2 rounded-md">
                        <Tooltip placement="top" title="Back">
                            <span onClick={() => navigate(-1)} className="!px-4 py-2 cursor-pointer flex items-center justify-center rounded-lg shadow-btn hover:bg-[#F3F2F5] border transition-all mr-3 bg-primary text-white hover:text-black">
                                <i className="fa fa-angle-left text-lg"></i>
                            </span>
                        </Tooltip>
                        <div>
                            <h3 className="text-lg lg:text-2xl font-semibold text-[#111827]">
                                Transaction Detail
                            </h3>
                        </div>
                    </div>
                    <div className="grid grid-cols-12 gap-6">
                        <div className="col-span-12">
                            <div className="shadow-box overflow-hidden rounded-lg bg-white  gap-4 shrink-0">
                                <div className="grid grid-cols-12 gap-5 p-4">
                                    <div className="col-span-6 flex flex-col">
                                        <label className="text-[14px] text-[#0000009c] tracking-wider mb-1">Date:</label>
                                        <p className="text-[13px] text-black capitalize bg-[#f5f5f5] min-h-[35px] rounded-md items-center px-3 py-2 leading-[18px] break-words">
                                            {moment(detail?.createdAt).format("DD MMM, YYYY")}
                                        </p>
                                    </div>
                                    <div className="col-span-6 flex flex-col">
                                        <label className="text-[14px] text-[#0000009c] tracking-wider mb-1">Transaction Status:</label>
                                        <p className="text-[13px] text-black capitalize bg-[#f5f5f5] min-h-[35px] rounded-md items-center px-3 py-2 leading-[18px] break-words">
                                            {detail?.transaction_status}
                                        </p>
                                    </div>
                                    <div className="col-span-6 flex flex-col">
                                        <label className="text-[14px] text-[#0000009c] tracking-wider mb-1">Tax:</label>
                                        <p className="text-[13px] text-black capitalize bg-[#f5f5f5] min-h-[35px] rounded-md items-center px-3 py-2 leading-[18px] break-words">
                                            6%
                                        </p>
                                    </div>
                                    <div className="col-span-6 flex flex-col">
                                        <label className="text-[14px] text-[#0000009c] tracking-wider mb-1">Total Amount:</label>
                                        <p className="text-[13px] text-black capitalize bg-[#f5f5f5] min-h-[35px] rounded-md items-center px-3 py-2 leading-[18px] break-words">
                                            ${detail?.IncludingTaxAmount || detail?.totalAmount || 0}
                                        </p>
                                    </div>
                                    {detail?.isPromo === "yes" &&
                                    <>
                                        <div className="col-span-6 flex flex-col">
                                            <label className="text-[14px] text-[#0000009c] tracking-wider mb-1">Discount:</label>
                                            <p className="text-[13px] text-black capitalize bg-[#f5f5f5] min-h-[35px] rounded-md items-center px-3 py-2 leading-[18px] break-words">
                                                {detail?.promotype !== "percentage" && "$"} {detail?.promoAmount} {detail?.promotype === "percentage" && "%"}
                                            </p>
                                        </div>
                                        <div className="col-span-6 flex flex-col">
                                            <label className="text-[14px] text-[#0000009c] tracking-wider mb-1">Paid Amount:</label>
                                            <p className="text-[13px] text-black capitalize bg-[#f5f5f5] min-h-[35px] rounded-md items-center px-3 py-2 leading-[18px] break-words">
                                                ${detail?.discountedAmount}
                                            </p>
                                        </div>
                                    </>
                                    }
                                </div>
                                <table className="w-full m-2 mb-4">
                                    <thead>
                                        <tr>
                                            <th className="text-left px-4">Product Name</th>
                                            <th className="text-left px-4">Sender Name</th>
                                            <th className="text-left px-4">Sender Email</th>
                                            <th className="text-left px-4">Recipient Name</th>
                                            <th className="text-left px-4">Recipient Email</th>
                                            <th className="text-left px-4">Recipient Mobile Number</th>
                                            <th className="text-left px-4">Price</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {detail?.cardDetails?.map((item: any, index: number) => {
                                            return <tr className="mt-4 border-t border-gray-200" key={index}>
                                                <td className="capitalize">{item?.customizeCardDetail?.name}</td>
                                                <td className="capitalize">{item?.sender_name}</td>
                                                <td>{detail?.email}</td>
                                                <td className="capitalize">{item?.recipient_name}</td>
                                                <td>{item?.recipient_email || "--"}</td>
                                                <td>{item?.recipient_mobileNo ? `+${item?.recipient_dialCode} ${item?.recipient_mobileNo}` : "--"}</td>
                                                <td>${item?.price || 0}</td>
                                            </tr>
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    )
}

export default TransactionDetail